export default {
  data() {
    return {
      settings: {
        sendLabel: 'submit',
      },
      groups: {
        'recovery-password': {
          visible: true,
          fields: {
            email: {
              type: 'email',
              model: null,
              placeholder: 'email',
              label: 'email',
              rules: 'required|email',
            },
          },
        },
      },
    };
  },
  methods: {
    init() {

    },
    callback() {
      this.$store.dispatch('recoveryPassword', {
        email: this.groups['recovery-password'].fields.email.model,
      });
    },
  },
};
